document.querySelectorAll('[data-module="compare"]').forEach(module => {
  const inputsContainer = module.querySelector('[data-role="inputs"]');
  const resultsContainer = module.querySelector('.results-content');
  const readMoreContainer = module.querySelector('.read-more');
  const readMoreLinks = module.querySelector('.read-more-links');
  const addBtn = module.querySelector('[data-action="add"]');
  const compareBtn = module.querySelector('[data-action="compare"]');
  const resetBtn = module.querySelector('[data-action="reset"]');

  let medicines = [];
  let debounceTimers = {};
  const MAX_MEDICINES = 20;
  const MIN_MEDICINES = 1;
  let isInitializing = true;

  async function init() {
    resultsContainer.style.display = 'none';
    readMoreContainer.style.display = 'none';

    const urlParams = new URLSearchParams(window.location.search);
    const substancesParam = urlParams.get('substances');
    const namesParam = urlParams.get('names');

    if (substancesParam && namesParam) {
      const substanceIds = substancesParam.split(',').filter(id => id.trim());
      const names = namesParam.split(',').map(n => decodeURIComponent(n.trim()));

      if (substanceIds.length >= MIN_MEDICINES && substanceIds.length === names.length) {
        await loadMedicinesFromUrl(substanceIds, names);
        isInitializing = false;
        return;
      }
    }

    for (let i = 0; i < MIN_MEDICINES; i++) {
      addInput();
    }
    validateCompare();
    isInitializing = false;
  }

  async function loadMedicinesFromUrl(substanceIds, names) {
    for (let i = 0; i < Math.min(substanceIds.length, names.length, MAX_MEDICINES); i++) {
      await addInputWithNameAndSubstance(names[i], substanceIds[i]);
    }

    validateCompare();

    const loadedMedicines = medicines.filter(m => m !== null);

    if (loadedMedicines.length >= MIN_MEDICINES) {
      setTimeout(() => handleCompare(), 1000);
    }
  }

  function createInput(index) {
    const wrapper = document.createElement('div');
    wrapper.className = 'input-wrapper';
    wrapper.dataset.index = index;

    const inputGroup = document.createElement('div');
    inputGroup.className = 'input-group';

    const input = document.createElement('input');
    input.type = 'text';
    input.placeholder = 'Søger...';
    input.className = 'medicine-input';
    input.dataset.index = index;
    input.autocomplete = 'off';

    const dropdown = document.createElement('div');
    dropdown.className = 'autocomplete-dropdown';
    dropdown.dataset.index = index;

    // Listeners
    input.addEventListener('input', e => {
      if (input.dataset.selected === 'true') {
        medicines[index] = null;
        input.dataset.selected = 'false';
        validateCompare();
        updateUrl();
      }

      handleInputChange(e, index);
    });

    input.addEventListener('focus', () => {
      if (input.dataset.selected === 'true') {
        input.select();
      }
    });

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.innerHTML = '&times;';
    removeBtn.className = 'remove-btn';
    removeBtn.setAttribute('aria-label', 'Fjern lægemiddel');
    removeBtn.addEventListener('click', () => removeInput(index));

    inputGroup.appendChild(input);
    inputGroup.appendChild(dropdown);
    wrapper.appendChild(inputGroup);
    wrapper.appendChild(removeBtn);

    return { wrapper, input, dropdown };
  }

  async function addInputWithNameAndSubstance(medicineName, substanceId) {
    const index = medicines.length;
    medicines.push(null);

    const { wrapper, input } = createInput(index);
    inputsContainer.appendChild(wrapper);

    updateRemoveButtonsState();

    try {
      // Search by the medicine name to find it
      const response = await fetch(`/api/medicinesearch/drug-interaction-autocomplete?q=${encodeURIComponent(medicineName)}&limit=100`);
      const results = await response.json();

      // Try to find exact match first, then by name, then by substance ID
      let medicine =
        results.find(m => m.name.toLowerCase() === medicineName.toLowerCase()) ||
        results.find(m => m.activeSub && m.activeSubstances.includes(substanceId)) ||
        results[0]; // Fallback to first result

      if (medicine) {
        medicines[index] = medicine;
        input.value = `${medicine.name} (${medicine.type})`;
        input.dataset.selected = 'true';

        validateCompare();
        updateUrl();
      }
    } catch (error) {
      console.error('Error loading medicine from URL:', error);
      input.disabled = false;
      input.placeholder = 'Søg efter lægemiddel eller virksomt stof';
    }
  }

  function addInput() {
    if (medicines.length >= MAX_MEDICINES) return;

    const index = medicines.length;
    medicines.push(null);

    const { wrapper } = createInput(index);
    inputsContainer.appendChild(wrapper);

    updateRemoveButtonsState();
  }

  // Always keep one input in medicinmix
  function updateRemoveButtonsState() {
    const totalInputs = inputsContainer.querySelectorAll('.input-wrapper').length;
    const disable = totalInputs <= MIN_MEDICINES;

    inputsContainer.querySelectorAll('.remove-btn').forEach(btn => {
      btn.disabled = disable;
      btn.setAttribute('aria-disabled', disable.toString());
    });
  }

  function removeInput(index) {
    const wrapper = inputsContainer.querySelector(`[data-index="${index}"]`);
    if (!wrapper) return;

    wrapper.remove();
    medicines[index] = null;

    validateCompare();
    updateUrl();
    updateRemoveButtonsState();
  }

  function handleInputChange(e, index) {
    const query = e.target.value.trim();
    const dropdown = inputsContainer.querySelector(`.autocomplete-dropdown[data-index="${index}"]`);

    if (debounceTimers[index]) {
      clearTimeout(debounceTimers[index]);
    }

    if (query.length < 2) {
      dropdown.innerHTML = '';
      dropdown.classList.remove('open');
      return;
    }

    debounceTimers[index] = setTimeout(async () => {
      await fetchAutocomplete(query, index, dropdown);
    }, 300);
  }

  async function fetchAutocomplete(query, index, dropdown) {
    try {
      const response = await fetch(`/api/medicinesearch/drug-interaction-autocomplete?q=${encodeURIComponent(query)}&limit=100`);
      const results = await response.json();

      if (results.length === 0) {
        dropdown.innerHTML = '<div class="no-results">Ingen resultater fundet</div>';
        dropdown.classList.add('open');
        return;
      }

      dropdown.innerHTML = '';
      dropdown.classList.add('open');

      results.forEach(item => {
        const suggestionItem = document.createElement('div');
        suggestionItem.className = 'autocomplete-item';
        suggestionItem.innerHTML = `
                    <div class="item-name">${item.name}</div>
                    <div class="item-type">${item.type}</div>
                `;
        suggestionItem.addEventListener('click', () => selectMedicine(item, index));
        dropdown.appendChild(suggestionItem);
      });
    } catch (error) {
      console.error('Error fetching autocomplete:', error);
      dropdown.innerHTML = '<div class="error-message">Fejl ved søgning</div>';
      dropdown.classList.add('open');
    }
  }

  function selectMedicine(medicine, index) {
    medicines[index] = medicine;

    const wrapper = inputsContainer.querySelector(`.input-wrapper[data-index="${index}"]`);
    const input = wrapper.querySelector('.medicine-input');
    const dropdown = wrapper.querySelector('.autocomplete-dropdown');

    input.value = `${medicine.name} (${medicine.type})`;
    input.dataset.selected = 'true';

    dropdown.innerHTML = '';
    dropdown.classList.remove('open');

    validateCompare();
    updateUrl();
  }

  function updateUrl() {
    if (isInitializing) return;

    const selectedMedicines = medicines.filter(m => m !== null);

    if (selectedMedicines.length === 0) {
      const url = new URL(window.location);
      url.searchParams.delete('substances');
      url.searchParams.delete('names');
      window.history.pushState({}, '', url);
      return;
    }

    const substanceIds = [];
    const names = [];

    selectedMedicines.forEach(med => {
      if (med.activeSubstances && med.activeSubstances.length > 0) {
        substanceIds.push(med.activeSubstances[0]);
        names.push(encodeURIComponent(med.name));
      }
    });

    if (substanceIds.length > 0) {
      const url = new URL(window.location);
      url.searchParams.set('substances', substanceIds.join(','));
      url.searchParams.set('names', names.join(','));
      window.history.pushState({}, '', url);
    }
  }

  function validateCompare() {
    const selectedMedicines = medicines.filter(m => m !== null);
    compareBtn.disabled = selectedMedicines.length < MIN_MEDICINES;

    if (medicines.length >= MAX_MEDICINES) {
      addBtn.disabled = true;
    } else {
      addBtn.disabled = false;
    }
  }

  function resetAll() {
    medicines = [];
    inputsContainer.innerHTML = '';
    resultsContainer.style.display = 'none';
    resultsContainer.innerHTML = '';

    const url = new URL(window.location);
    url.searchParams.delete('substances');
    url.searchParams.delete('names');
    readMoreContainer.style.display = 'none';
    window.history.pushState({}, '', url);

    isInitializing = true;
    for (let i = 0; i < MIN_MEDICINES; i++) {
      addInput();
    }
    validateCompare();
    isInitializing = false;
  }

  async function handleCompare() {
    const selectedMedicines = medicines.filter(m => m !== null);
    if (selectedMedicines.length < MIN_MEDICINES) return;

    compareBtn.disabled = true;
    const originalText = compareBtn.textContent;
    compareBtn.innerHTML = '<span class="spinner"></span>Undersøger...';

    const requestBody = {
      searchSubstances: selectedMedicines.map(m => ({
        substances: m.activeSubstances || []
      })),
      searchDrugIDs: []
    };

    try {
      const response = await fetch('/api/medicinesearch/drug-interaction-recommendations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();

      resultsContainer.style.display = 'block';
      renderResults(data, selectedMedicines);

      resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      console.error('Error getting recommendations:', error);
      resultsContainer.style.display = 'block';
      resultsContainer.innerHTML = '<div class="error-message global-component">Der opstod en fejl. Prøv igen senere.</div>';
    } finally {
      compareBtn.disabled = false;
      compareBtn.textContent = originalText;
    }
  }

  function renderCombination(combo, severityColor) {

    return `
      <div class="combinations">     
        <div class="columns ${severityColor}">
          <div class="combination-column">
            <h3 class="style-h6">${combo.substance1.name}</h3>
            ${renderAccordion(combo.substance1)}
          </div>
  
          <div class="combination-column">
            <h3 class="style-h6">${combo.substance2.name}</h3>
            ${renderAccordion(combo.substance2)}
          </div>
        </div>
        ${(combo.problemsWithSimultaneousUse || combo.specialPrecautions) ? `
          <div class="results-precautions">
            ${combo.problemsWithSimultaneousUse ? `<p>${combo.problemsWithSimultaneousUse}</p>` : ''}
            ${combo.specialPrecautions ? `<p>${combo.specialPrecautions}</p>` : ''}
          </div>
        ` : ''}
      </div>
      `;
  }

  function renderSelectedMedicines(selectedMedicines, combo) {
    if (!combo) {
      return '';
    }

    if (selectedMedicines.length === 1) {
      const medicine = selectedMedicines[0];
      return `
        <div class="medicine-items-wrapper">
          <div class="medicine-item">
            <div class="medicine-item-details">
              <p class="style-base">${medicine.name} (${medicine.type})</p>
            </div>
            <div data-accordion-container class="accordion-component">
                ${renderAccordion(combo.substance1)}
            </div>
          </div>
        </div>
      `;
    }

    return `
      <div class="medicine-items-wrapper">
             ${selectedMedicines.map((medicine, index) => {
      let substance = index === 0 ? combo.substance1 : index === 1 ? combo.substance2 : null;
      return `
              <div class="medicine-item">
                <div class="medicine-item-details">
                  <p class="style-base">${medicine.name} (${medicine.type})</p>
                </div>
                <div data-accordion-container class="accordion-component">
                    ${substance ? renderAccordion(substance) : ''}
                </div>
              </div>
            `;
    }).join('')}
        </div>
      </div>
    `;
  }

  function renderResults(data, selectedMedicines) {
    resultsContainer.innerHTML = '';

    if (!data.interactions || data.interactions.length === 0) {
      resultsContainer.innerHTML = `
                <div class="global-component no-results-mix">
                    <h2 class="style-h4"> Din søgning gav intet resultat</h2>
                    <p class="style-base">På nuværende tidspunkt har Lægemiddelstyrelsen ikke kendskab til videnskabelige undersøgelser, der beskriver samtidig brug af det/de præparater, du har søgt på. Der kan være tale om en kombination, hvor der ikke kan drages konklusioner på baggrund af nuværende viden.</p>
                </div>
            `;
      return;
    }

    resultsContainer.innerHTML = `
      <div class="global-component">
        <div class="medicine-items">
            <h3 class="style-h5">Din søgning</h3>
            ${renderSelectedMedicines(selectedMedicines)}
        </div>
      /div>
    `;

    const firstCombo =
      data.interactions?.[0]?.recommendations?.[0]?.combinations?.[0];

    let resultsHtml = `
            <div class="global-component">
                <div class="medicine-items">
                    <h2 class="style-h4">Din søgning</h2>
                    ${renderSelectedMedicines(selectedMedicines, firstCombo)}
                </div>
            </div>
        `;

    data.interactions.forEach(interaction => {
      interaction.recommendations.forEach(rec => {

        // set severity background
        const severityColor = interaction.severity ? `bg-${interaction.severity}` : '';

        // set severity title
        let severityType = '';
        switch (interaction.severity) {
          case 'yellow': severityType = 'potentielt problematiske'; break;
          case 'red': severityType = 'problematiske'; break;
          case 'green': severityType = 'uproblematiske'; break;
          default: severityType = '';
        }

        const combinationCount = interaction.recommendations.reduce((acc, rec) => acc + rec.combinations.length, 0);

        const severityTitle = `${combinationCount} ${severityType} kombinationer`;

        resultsHtml += `
                    <div class="global-component">
                        <div class="results-wrapper">
                            <h2 class="result-header style-h4">${severityTitle}</h2>
                            ${rec.recommendationWarning ? `<p class="style-base">${rec.recommendationWarning}</p>` : ''}
                            ${rec.combinations[0]?.sideEffects
            ? `<p class="style-base">${rec.combinations[0].sideEffects}</p>`
            : ''
          }
                            <div data-accordion-container class="accordion-component">
                                <div class="accordion-items">
                                    ${rec.combinations.map(combo => renderCombination(combo, severityColor)).join('')}
                                </div>
                            </div>
                        </div>
                    </div>
                `;

      });
    });

    readMoreLinks.innerHTML = renderReadMoreLinks(selectedMedicines);

    resultsContainer.innerHTML = resultsHtml;
    initializeAccordions();
  }

  function renderReadMoreLinks(selectedMedicines) {
    const pathName = window.location.pathname;
    readMoreContainer.style.display = 'flex';

    return selectedMedicines
      .map(item => {
        let link = `${pathName}`;
        const activeSubstances = item["activeSubstances"];

        if (activeSubstances.length > 0) {
          link = `${link}?substances=${activeSubstances[0]}`;
        }

        if (item.slug) {
          link = activeSubstances.length > 0 ? `${link}&names=${item.slug}` : `${link}?names=${item.slug}`;
        }

        return `<a href="${link}" class="read-more-link button button-secondary">${item.name}</a>`
      })
      .join("<br>");
  }

  function renderAccordion(data) {
    if (!data) return '';

    const normalized = normalizeAccordionData(data);

    const { name, included } = normalized;
    const count = included.length;

    return `
      <article class="accordion closed" data-accordion>
        <div class="accordion-heading">
          <button class="accordion-toggler closed" data-accordion-toggler aria-label="Fold element ud">
            <div class="toggler-icons">
              <span class="icon plus"><svg class="plus" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>
              <span class="icon minus"><svg class="minus" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>
            </div>
            <p>${formatIncludedIn(name, included)}</p>
          </button>
        </div>
  
        <div class="accordion-content hidden" data-accordion-content>
          <div class="accordion-content-wrapper">
            <div class="accordion-content-inner">
            ${count
        ? `
                  <ul class="included-list">
                    ${included.map(x => `
                      <li class="comb">${x.medicineName || x.slug}</li>
                    `).join('')}
                  </ul>
                `
        : ''
      }
            </div>
          </div>
        </div>
      </article>
    `;
  }

  function normalizeAccordionData(data) {
    if (data.included) {
      return {
        name: data.name || '',
        included: data.included
      };
    }

    if (data.activeSubstances) {
      return {
        name: data.name,
        included: [
          { medicineName: data.name, slug: data.slug },
          ...data.activeSubstances.map(s => ({ slug: s }))
        ]
      };
    }

    if (data.includedIn) {
      return {
        name: data.name,
        included: data.includedIn
      };
    }

    return {
      name: data.name || 'Unknown',
      included: []
    };
  }

  function formatIncludedIn(name, included = []) {
    if (!name) return '';

    const count = included.length;

    return count > 1
      ? `Indgår i ${name} + ${count - 1} lægemidler`
      : name;
  }

  function initializeAccordions() {
    resultsContainer.querySelectorAll('[data-accordion-toggler]').forEach(toggler => {
      toggler.addEventListener('click', function () {
        const accordion = this.closest('[data-accordion]');
        const content = accordion.querySelector('[data-accordion-content]');
        const isOpen = !accordion.classList.contains('closed');

        if (isOpen) {
          accordion.classList.add('closed');
          this.classList.add('closed');
          content.classList.add('hidden');
          content.setAttribute('aria-hidden', 'true');
        } else {
          accordion.classList.remove('closed');
          this.classList.remove('closed');
          content.classList.remove('hidden');
          content.removeAttribute('aria-hidden');
        }
      });
    });
  }

  document.addEventListener('click', e => {
    if (!e.target.closest('.input-group')) {
      document.querySelectorAll('.autocomplete-dropdown').forEach(dropdown => {
        dropdown.classList.remove('open');
      });
    }
  });

  addBtn.addEventListener('click', addInput);
  compareBtn.addEventListener('click', handleCompare);
  resetBtn.addEventListener('click', resetAll);

  init();
});
